import {
  BoxedBatteryIcon2024,
  BoxedDiamondIcon,
  BoxedSensingIcon,
  BoxedWaterDropIcon,
} from '@jouzen/ecom-components';

import type { TechSpecsContent } from '@/app/[locale]/product/_types/carouselTypes';
import { RingFinishEnum } from '@/app/enums/RingFinishEnum';
import type { RingFinish } from '@/app/types/ring';
import type { Products_content_listProducts_wizard_finishStep_carouselImages } from '@/queries/types/Products';

interface CarouselImage
  extends Omit<
    Products_content_listProducts_wizard_finishStep_carouselImages,
    'content'
  > {
  content: TechSpecsContent | null;
}

type TempCarouselImages = Record<RingFinish, CarouselImage[]>;

const TECH_SPECS_CONTENT: TechSpecsContent = {
  title: 'wizard_tech_specs_title',
  list: [
    {
      icon: BoxedDiamondIcon,
      heading: 'fully_titanium_design',
    },
    {
      icon: BoxedBatteryIcon2024,
      heading: '8_days_battery_life',
    },
    {
      icon: BoxedSensingIcon,
      heading: 'smart_sensing',
    },
    {
      icon: BoxedWaterDropIcon,
      heading: 'water_resistant',
    },
  ],
};

const TECH_SPECS = {
  altMsgKey: 'wizard_tech_specs_image_alt',
  content: TECH_SPECS_CONTENT,
  inverseText: true,
  mobileSrc: null,
  originalSrc: 'product/wizard/tech-specs.jpg',
  thumbnailSrc: 'product/wizard/tech-specs.jpg',
  originalSrcKey: null,
};

export const carouselImages: TempCarouselImages = {
  [RingFinishEnum.Black]: [
    {
      altMsgKey: 'product_catalog_color_black',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-black.mp4',
      originalSrc: 'product/wizard/or4-black.mp4',
      thumbnailSrc: 'product/wizard/or4-black-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_black_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-black-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-black-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_black_lifestyle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-black-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-black-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.BrushedSilver]: [
    {
      altMsgKey: 'product_catalog_color_brushed_silver',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-brushed-silver.mp4',
      originalSrc: 'product/wizard/or4-brushed-silver.mp4',
      thumbnailSrc: 'product/wizard/or4-brushed-silver-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_brushed_silver_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-brushed-silver-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-brushed-silver-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_brushed_silver_lifestyle',
      content: null,
      inverseText: true,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-brushed-silver-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-brushed-silver-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.Gold]: [
    {
      altMsgKey: 'product_catalog_color_gold',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-gold.mp4',
      originalSrc: 'product/wizard/or4-gold.mp4',
      thumbnailSrc: 'product/wizard/or4-gold-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_gold_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-gold-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-gold-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_gold_lifestyle',
      content: null,
      inverseText: true,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-gold-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-gold-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.Silver]: [
    {
      altMsgKey: 'product_catalog_color_silver',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-silver.mp4',
      originalSrc: 'product/wizard/or4-silver.mp4',
      thumbnailSrc: 'product/wizard/or4-silver-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_silver_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-silver-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-silver-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_silver_lifestyle',
      content: null,
      inverseText: true,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-silver-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-silver-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.Stealth]: [
    {
      altMsgKey: 'product_catalog_color_stealth',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-stealth.mp4',
      originalSrc: 'product/wizard/or4-stealth.mp4',
      thumbnailSrc: 'product/wizard/or4-stealth-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_stealth_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-stealth-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-stealth-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_stealth_lifestyle',
      content: null,
      inverseText: true,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-stealth-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-stealth-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.RoseGold]: [
    {
      altMsgKey: 'product_catalog_color_rosegold',
      content: null,
      inverseText: false,
      mobileSrc: 'product/wizard/or4-rose-gold.mp4',
      originalSrc: 'product/wizard/or4-rose-gold.mp4',
      thumbnailSrc: 'product/wizard/or4-rose-gold-profile-thumb.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_rose_gold_angle',
      content: null,
      inverseText: false,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-rose-gold-angle.jpg',
      thumbnailSrc: 'product/wizard/or4-rose-gold-angle.jpg',
      originalSrcKey: null,
    },
    {
      altMsgKey: 'product_catalog_color_rose_gold_lifestyle',
      content: null,
      inverseText: true,
      mobileSrc: null,
      originalSrc: 'product/wizard/or4-rose-gold-lifestyle-v2.jpg',
      thumbnailSrc: 'product/wizard/or4-rose-gold-lifestyle-v2.jpg',
      originalSrcKey: null,
    },
    TECH_SPECS,
  ],
  [RingFinishEnum.Titanium]: [],
  [RingFinishEnum.Rose]: [],
};
